import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/fila`

    return {
        paciente: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
            }
        },
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getImpressoes(queryParms = {}) {

            return repository.get(`${baseUrl}/impressao?${urlUtil.serialize(queryParms)}`)
        },
        getTentativasContato(queryParms = {}) {

            return repository.get(`${baseUrl}/tentativa-contato?${urlUtil.serialize(queryParms)}`)
        },
        createTentativaContato(solicitacaoId, queryParms) {

            return repository.get(`${baseUrl}/tentativa-contato/${solicitacaoId}?${urlUtil.serialize(queryParms)}`)
        },
        storeTentativaContato(params) {

            return repository.post(`${baseUrl}/tentativa-contato`, params)
        },
        updatePaciente(pacienteId, params) {

            return repository.put(`${baseUrl}/paciente/${pacienteId}`, params)
        },
        editSolicitacao(solicitacaoId) {

            return repository.get(`${baseUrl}/${solicitacaoId}/edit-solicitacao`)
        },
        updateSolicitacao(solicitacaoId, params) {

            return repository.put(`${baseUrl}/solicitacao/${solicitacaoId}`, params)
        },
    }
}